import { useContext } from 'react';

// auth provider
import { TournamentsContext } from 'contexts/TournamentsContext';
// import AuthContext from 'contexts/Auth0Context';
// import AuthContext from 'contexts/JWTContext';
// import AuthContext from 'contexts/AWSCognitoContext';

// ==============================|| AUTH HOOKS ||============================== //

const useTournaments = () => {
    const context = useContext(TournamentsContext);

    if (!context) throw new Error('context must be use inside provider');

    return context;
};

export default useTournaments;
